// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

function Button(
  props: {
    onClick: () => any,
    disabled?: ?boolean,
    className?: string,
    type?: string
  },
) {
  return (
    <button
      className={props.className}
      onClick={props.onClick}
      type={props.type}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
}

Button.defaultProps = {
  disabled: false,
  className: '',
  type: 'button'
};

Button.propTypes = {
  /**
   * Handler to be called when the user click the button
   */
  onClick: PropTypes.func.isRequired,

  /**
   * If true, disable all interactions for this component.
   */
  disabled: PropTypes.bool,

  className: PropTypes.string,

  type: PropTypes.string,
};

export default Button;
